import { combineReducers } from "redux";

import configReducer from "./ConfigSlice";
import sessionReducer from "./SessionSlice";
import companiesReducer from "./CompanySlice";
import jobsReducer from "./JobsSlice";
import usersReducer from "./UserSlice";
import adminReducer from "./AdminSlice";

const rootReducer = combineReducers({
  configState: configReducer,
  sessionState: sessionReducer,
  companiesState: companiesReducer,
  jobsState: jobsReducer,
  usersState: usersReducer,
  adminState: adminReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
